import RestrictedRegistry from '../../../components/RestrictedRegistry';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import PreloaderWidget from '../../../components/Loader';
import PageTitle from '../../../components/PageTitle';
import {
    incubatee_details,
    change_status,
    internship_application_details,
    change_application_status,
    reject_application_status,
} from '../../../helpers/actions/api.functions';

const InternshipApplicationDetails = () => {
    let userdata = localStorage.getItem('active_user') ? JSON.parse(localStorage.getItem('active_user')) : null;
    const param = useParams();
    const [data, setData] = useState({});
    const [isActive, setIsActive] = useState(true);

    useEffect(() => {
        listData(param.id);
    }, [param.id]);

    const listData = (id) => {
        internship_application_details(id)
            .then((res) => {
                setData(res);
                setIsActive(false);
            })
            .catch((err) => {
                setIsActive(false);
                toast.error(err.response.data.message);
            });
    };
    if (isActive) {
        return <PreloaderWidget />;
    }
    const openFile = (file) => {
        if (file) {
            window.open(file, '_blank');
        }
    };
    const updateStatus = (status) => {
        setIsActive(true);

        if (status === 2) {
            const payload = {
                id: param.id,
                status: status,
            };
            reject_application_status(payload)
                .then((res) => {
                    toast.success(res.message || 'Application rejected');
                    listData(param.id);
                })
                .catch((err) => {
                    toast.error(err.response?.data?.message || 'Something went wrong during rejection');
                })
                .finally(() => {
                    setIsActive(false);
                });
        } else {
            const payload = {
                id: param.id,
                status: status,
            };

            change_application_status(payload)
                .then((res) => {
                    toast.success(res.message || 'Status updated successfully');
                    listData(param.id);
                })
                .catch((err) => {
                    toast.error(err.response?.data?.message || 'Something went wrong');
                })
                .finally(() => {
                    setIsActive(false);
                });
        }
    };

    return (
        <React.Fragment>
            <Row className="page-title">
                <Col md={12}>
                    <PageTitle
                        breadCrumbItems={[
                            { label: 'Internship Application List', path: '/internship-application-list' },
                            { label: 'Details', path: '/internship-application-detail', active: true },
                        ]}
                        title={'Internship Application Details'}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={6} xl={12} className="mx-auto">
                    <Card>
                        <CardBody className="pb-0">
                            <RestrictedRegistry user={data.user} sourceType="internship_application" sourceId={data.id} canMark={data.can_restrict_user} onChanged={() => listData(param.id)} />
                            <div className="mt-3 pt-2 ">
                                {/* <h4 className="mb-3 font-size-15">Detailed  Information</h4> */}
                                <div className="table-responsive incu-detail">
                                    <table className="table  table-striped  text-muted">
                                        <tbody>
                                            <tr>
                                                <th scope="row">Name</th>
                                                <td className="text-capitalize">{data?.user?.name || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Email</th>
                                                <td className="text-lowercase">{data?.user?.email || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Mobile</th>
                                                <td>{data?.user?.mobile || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">WhatsApp No</th>
                                                <td>{data?.user?.whatsapp_no || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Gender</th>
                                                <td>{data?.gender || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Date of Birth</th>
                                                {/* <td>{data?.dob ? new Date(data.dob).toLocaleDateString() : '-'}</td> */}
                                                <td>
                                                    {data?.dob
                                                        ? new Date(data.dob)
                                                              .toLocaleDateString('en-GB') // en-GB gives dd/mm/yyyy
                                                              .replace(/\//g, '-') // replace / with -
                                                        : '-'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">University</th>
                                                <td>{data?.university || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Degree Program</th>
                                                <td>{data?.degree_program || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Major</th>
                                                <td>{data?.major || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Year of Study</th>
                                                <td>{data?.year_of_study || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">CGPA</th>
                                                <td>{data?.cgpa || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Duration</th>
                                                <td>{data?.duration || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Start Date</th>
                                                {/* <td>
                                                    {data?.start_date
                                                        ? new Date(data.start_date).toLocaleDateString()
                                                        : '-'}
                                                </td> */}
                                                <td>
                                                    {data?.start_date
                                                        ? new Date(data.start_date)
                                                              .toLocaleDateString('en-GB')
                                                              .replace(/\//g, '-')
                                                        : '-'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Skills</th>
                                                <td>{data?.skills || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Interests</th>
                                                <td>
                                                    {Array.isArray(data?.interests) ? data.interests.join(', ') : '-'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Why Interested?</th>
                                                <td>{data?.why_interested || '-'}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Resume</th>
                                                <td>
                                                    {data?.resume ? (
                                                        <Button
                                                            size="sm"
                                                            color="info"
                                                            onClick={() => openFile(data.resume)}>
                                                            View Resume
                                                        </Button>
                                                    ) : (
                                                        'Not uploaded'
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {data.status === 'pending' && (
                                        <div className="d-flex justify-content-center incu-btn border-top pb-5">
                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm mr-1"
                                                onClick={() => updateStatus(1)}>
                                                Accept
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() => updateStatus(2)}>
                                                Reject
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default InternshipApplicationDetails;
